import { render, staticRenderFns } from "./FrontPostDoubleTrebleCrochetIcon.vue?vue&type=template&id=351b1605&scoped=true"
import script from "./FrontPostDoubleTrebleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./FrontPostDoubleTrebleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./FrontPostDoubleTrebleCrochetIcon.vue?vue&type=style&index=0&id=351b1605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351b1605",
  null
  
)

export default component.exports